import React, { FunctionComponent } from 'react';
import styles from './no-results-component.module.scss';
import { Card, Icon } from 'rs-emd-ui-atoms';
import { INoResultsPage } from '../../../models/plp/no-results/no-results.model';
import { getLabel } from '../../..';
import { MetaDataAndTagging } from '../../shared';

type NoResultsProps = { data: INoResultsPage };

export const NoResults: FunctionComponent<NoResultsProps> = (props: NoResultsProps) => {
  return (
    <div className={`${styles['no-results-wrapper']} inner-page-wrapper`}>
      {/* Head data */}
      <MetaDataAndTagging metaData={props.data.metaData} tagging={props.data.tagging} />

      <div className={styles['no-results-heading-container']}>
        <p className={styles['no-results-heading']}>{getLabel(props.data.labels, 'page_title')}</p>
        <p className={styles['no-results-subheading']}>{getLabel(props.data.labels, 'instructions')}</p>
      </div>

      <Card squareCorners={true} className={`${styles['search-tips-card']}`}>
        <div className={styles['search-tips-container']}>
          <p className={styles['search-tips-title']}>{getLabel(props.data.labels, 'search_tips_title')}</p>

          <ul className={styles['search-tips-ul']}>
            {getLabel(props.data.labels, 'search_tips_details')
              .split('#*')
              .filter((details) => details !== '')
              .map((details) => {
                return <li key={details}>{details}</li>;
              })}
          </ul>
        </div>
      </Card>

      <Card squareCorners={true} className={`${styles['need-help-card']}`}>
        <div className={styles['need-help-container']}>
          <p className={styles['need-help-title']}>{getLabel(props.data.labels, 'help_title')}</p>

          <div className={styles['need-help-info']}>
            <div className={styles['need-help']}>
              <p className={styles['need-help-details']}>{getLabel(props.data.labels, 'phone_instructions')}</p>
              <a className={styles['icon-details']} href={`tel: ${getLabel(props.data.labels, 'phone_details')}`}>
                <Icon name={'phone'} width={24} height={24} />
                <p>{getLabel(props.data.labels, 'phone_details')}</p>
              </a>
            </div>

            <div className={styles['need-help']}>
              <p className={styles['need-help-details']}>{getLabel(props.data.labels, 'email_instructions')}</p>
              <a className={styles['icon-details']} href={`mailto: ${getLabel(props.data.labels, 'email_details')}`}>
                <Icon name={'envelope'} width={24} height={24} />
                <p>{getLabel(props.data.labels, 'email_details')}</p>
              </a>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
